/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAuthenticationRequestDto } from '../../models/lexplus-authentication-request-dto';
import { LexplusLoginResultDto } from '../../models/lexplus-login-result-dto';

export interface AuthenticationControllerLoginV1$Params {
      body: LexplusAuthenticationRequestDto
}

export function authenticationControllerLoginV1(http: HttpClient, rootUrl: string, params: AuthenticationControllerLoginV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusLoginResultDto>> {
  const rb = new RequestBuilder(rootUrl, authenticationControllerLoginV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusLoginResultDto>;
    })
  );
}

authenticationControllerLoginV1.PATH = '/v1/authentication/loginWithUsernameAndPassword';
